export const VISUALISATION_TYPES = {
  LOCATION: 'LOCATION',
  HEATMAP: 'HEATMAP',
  CHOROPLETH: 'CHOROPLETH',
};
